<template>
  <div class="app">
    <h1>联系我们</h1>
    <Header :activeIndex="'1-2'" />
    <nav class="tiaozhuan" aria-label="面包屑导航"><router-link to="/" style="cursor: pointer; color: inherit; text-decoration: none;">首页</router-link><span>&nbsp;&gt;&gt;&nbsp;</span><span>联系我们</span></nav>
    
    <main class="margintop">
      <div class="biaoti">公司介绍：</div>
      <div class="jianjie">
        名企科技是工商局、财政局批复的财税服务平台，具有政府颁发的《代理记账许可证》服务资质。公司成立于2017年2月，位于北京市核心区-西城区，办公地址在西直门外大街1号院2号楼19C2。公司主要业务有：工商注册、代理记账、工商变更、股权变更、注销清算、申请许可证、申请资质、商标代办、高新企业代理申报、社保服务托管、信息化建设等服务。<br><br>
        名企科技拥有专业的人才队伍、丰富的服务经验、完备的资源配套、规范的管理体系。公司通过科技产品为客户提供深度、专业的财务服务及企业服务。名企科技自主研发"名企财务助手"小程序，可以协助客户计算税费、起草合同、制作网店、制作电子名片、收藏和转发发票抬头、计算退休年龄，拥有几十项软件著作权，是科技财务服务的实干企业。<br><br>
        公司成立以来，名企科技已经为几千家企业提供服务，获得了客户们的广泛认可和好评。
      </div>
      <div class="juzhong">
        <div class="fuwu01">
          <div class="fuwu02">  
            <div class="fuwu03">注册<br>公司</div>
            <div class="fuwu04">不续费<br>地址
            </div>
            <div class="fuwu04">代理<br>记账</div>
            <div class="fuwu04">社保<br>托管</div>
            <div class="fuwu04">刻章<br>补照</div>
          </div>
          <div class="fuwu05">
            <div class="fuwu06">变更<br>注销</div>
            <div class="fuwu07">审计<br>咨询</div>
            <div class="fuwu07">资质<br>许可</div>
            <div class="fuwu07">商标<br>软著</div>
            <div class="fuwu07">税务<br>筹划</div>
          </div>

        </div>
      </div>
      <div class="biaoti1">全国服务：</div>
      <div class="jianjie">
        名企科技的的业务范围已经覆盖：北京市朝阳区，海淀区、西城区、东城区、丰台区、石景山区、怀柔区、密云区、房山区、门头沟区、延庆区、平谷区、经济开发区、大兴区、通州区等北京各个区域，以及上海、广州、深圳、内蒙古、湖北、江西、天津、重庆、河南等全国多个省市。
      </div>
      <div class="juzhong">
        <img loading="lazy" class="huanhang1" :src="require('../assets/img/mapofChina.jpg')"
          alt="名企科技全国服务区域示意图">
      </div>
      <div class="biaoti1">服务的公司：</div>
      <div class="juzhong">
        <div class="kehu">
          <div>
            <div class="dazi">
              小型企业
            </div>
            <div class="zuoer">
              <ul style="list-style-type: none;">
                <li>♢ 初创公司</li>
                <li>♢ 小微企业</li>
              </ul>
            </div>
          </div>
          <div class="youyi">
            <ul>
              <li>注册执照、刻章</li>
              <li>代理记账、报税</li>
              <li>发票、社保托管</li>
            </ul>
          </div>
        </div>
        <div class="kehu1">
          <div>
            <div class="dazi">
              中型公司
            </div>
            <div class="zuoer">
              <ul style="list-style-type: none;">
                <li>♢ A、B轮公司</li>
                <li>♢ 事业单位</li>
              </ul>
            </div>
          </div>
          <div class="youyi">
            <ul>
              <li>记账报税</li>
              <li>财务梳理、优化</li>
              <li>办理资质、许可</li>
            </ul>
          </div>
        </div>
        <div class="kehu1">
          <div>
            <div class="dazi">
              大型公司
            </div>
            <div class="zuoer">
              <ul style="list-style-type: none;">
                <li>♢ 上市公司</li>
                <li>♢ 国有企业</li>
              </ul>
            </div>
          </div>
          <div class="youyi">
            <ul>
              <li>工商、税务服务</li>
              <li>办理资质、许可</li>
              <li>财务梳理、优化</li>
            </ul>
          </div>
        </div>
      </div>
    </main>

    <section class="margintop">
      <!-- <div class="titel">北京名企科技有限公司，成立于2017年，是专业的财务服务机构，为大型企业、中型企业、小微企业、初创企业提供工商注册、代理记账、变更注销、知识产权、社保公积金托管等服务。</div> -->
      <div class="tongyi">
        <div class="titel1"><span>公司地址：</span><span class="content">北京市西城区西直门外大街1号院2号楼(西环广场T2座)19C2</span></div>
        <div class="titel1"><span>乘车路线：</span><span class="content">地铁2号线、地铁4号线、地铁13号线西直门站，下车即到</span></div>
        <div class="titel1"><span>联系方式：</span><span class="content"
            style="font-weight: 900;">1391&nbsp;0303&nbsp;798</span></div>
        <div class="titel1"><span>邮箱：</span><span class="content">mingqikejihr@bjmqkj.com</span></div>
      </div>

      <div class="juzhong">
        <div style="display:flex;flex-direction: column;">
          <div class="titel2">微信扫码咨询：</div>
          <div class="tupianjuz">
            <img loading="lazy" src="../assets/img/wx.png" alt="联系我们微信二维码" class="tupian">
          </div>
        </div>
        <div style="display:flex;flex-direction: column;">
          <div class="titel2">名企财务小程序：</div>
          <div class="tupianjuz">
            <img loading="lazy" src="../assets/img/xiaochengxu.jpg" alt="名企财务小程序二维码" class="tupian1">
          </div>
        </div>
      </div>
    </section>

    <section class="margintop1">
      <div class="juli">
        <span class="titel2">公司位置：</span>
        <div></div>
        <div class="juzhong1"><img loading="lazy" src="../assets/img/lou.jpg" class="weizhitupian" alt="名企科技办公楼外观"></div>

        <p></p>
        <span class="titel2">地图导航：</span><span class="titel3">(高德地图搜"北京名企科技"即可)</span>
        <div></div>
        <div class="juzhong1"><img loading="lazy" src="../assets/img/map.png" class="weizhitupian" alt="名企科技办公地址地图位置"></div>
        <p></p>
      </div>
    </section>
    
    <Youshi />
    <Footer />
  </div>
</template>


<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Youshi from '@/components/Youshi.vue'

export default {
  name: 'contact',
  components: {
    Header,
    Footer,
    Youshi
  },
  data() {
    return {
      imgCount: 0,
      currentIndex: 0,
      intervalID: '',
      pppclose: true
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    // console.log(this.$root.showData.showData);
    this.$root.showData.showData = false;
  },
  methods: {
    pppopco() {
      this.$root.ppp.ppp = !this.$root.ppp.ppp
    },
    pathIndex() {
      this.$router.push('/');
    },
    pathRemen() {
      this.$router.push('/remen');
    },
    pathJizhang() {
      this.$router.push('/jizhang')
    },
    pathgongshang() {
      this.$router.push('/gongshang')
    },
    pathshuiwu() {
      this.$router.push('/shuiwu');
    },
    pathzhichan() {
      this.$router.push('/zhichan')
    },
    pathxuke() {
      this.$router.push('/xuke')
    },
    pathrenshi() {
      this.$router.push('/renshi')
    },
    pathxueyuan() {
      this.$router.push('/xueyuan');
    },
    pathxinxi() {
      this.$router.push('/xinxi')
    },
    pathcontact() {
      this.$router.push('/contact')
    },
  }
}
</script>

<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {
  .el-menu--horizontal>.el-menu-item {
    float: left;
    height: 30px !important;
    line-height: 30px !important;
    margin: 0;
  }

  .responsive-carousel el-carousel el-carousel--horizontal {
    height: 128px !important;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }
}
</style>

<style scoped>
/* 我们的客户 */
.kehu:hover .dazi,
.kehu:hover .zuoer,
.kehu:hover .youyi,
.kehu1:hover .dazi,
.kehu1:hover .zuoer,
.kehu1:hover .youyi {
  border-color: #c9c9c9;
}

/* 保持其他已有样式 */
.kehu,
.kehu1 {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.kehu1 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 40px;
}

.dazi {
  height: 67px;
  width: 130px;
  border: 6px solid #d22525;
  font-size: 25px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 10px;
}

.zuoer {
  height: 69px;
  width: 130px;
  border-left: 6px solid #d22525;
  border-right: 6px solid #d22525;
  border-bottom: 6px solid #d22525;
  font-size: 18px;
  margin-top: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-left-radius: 10px;
  flex-direction: column;
  text-align: left;
}

.youyi {
  height: 142px;
  width: 153px;
  border-top: 6px solid #d22525;
  border-right: 6px solid #d22525;
  border-bottom: 6px solid #d22525;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  flex-direction: column;
  text-align: left;
}


.fangkuai {
  list-style-type: square;
  margin-top: 0px;
  padding-left: 10px;
}

.yuanquan {
  list-style-type: circle;
}


.biaoti {
  font-size: 20px;
  font-weight: 700;
}

.biaoti1 {
  font-size: 20px;
  font-weight: 700;
  margin-top: 15px;
}

.jianjie {
  margin-top: 10px;
  color: black;
  line-height: 32px;
  font-size: 16px;
}

.juzhong {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}

.fuwu01 {
  background-color: #ffc205;
  width: 574px;
  height: 196px;
  font-weight: 700;
  margin-top: 10px;
}

.fuwu02 {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: 11px;
}

.fuwu03 {
  width: 85px;
  height: 79px;
  background-color: #fdff05;
  color: #4675c5;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.fuwu04 {
  width: 85px;
  height: 79px;
  margin-left: 20px;
  background-color: #fdff05;
  color: #4675c5;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.fuwu05 {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: 16px;
}

.fuwu06 {
  width: 85px;
  height: 79px;
  background-color: #4675c5;
  color: #fdff05;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.fuwu07 {
  width: 85px;
  height: 79px;
  margin-left: 20px;
  background-color: #4675c5;
  color: #fdff05;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.huanhang {
  margin-top: 10px;
  width: 574px;
  height: 196px;
  display: flex;
}

.huanhang1 {
  margin-top: 10px;
  width: 590px;
  height: 378px;
  display: flex;
}

.tiaozhuan {
  text-align: left;
  margin-bottom: 0.83em;
  font-size: 18px;
  font-weight: 500;
}


/* 其他 */
ul,
li {
  margin: 0;
  padding: 0;

}

h1 {
  font-size: 0%;
}

.margintop {
  text-align: left;
  /* margin-top: 118px; */
  margin-left: 25%;
  margin-right: 25%;
}

.tiaozhuan {
  text-align: left;
  margin-top: 118px;
  margin-bottom: 0.83em;
  font-size:18px;
  margin-left:19.5%;
  font-weight: 500;
}

.margintop1 {
  text-align: left;
  margin-top: 10px;
}

.juli {
  margin-left: 25%;
  margin-right: 25%;
  margin-top: 15px;
}

.addressimg {
  width: 30%;
  height: auto;
  margin-left: auto;
  margin-right: auto;
}

.titel {
  font-size: 18px;
  font-weight: 900;
  margin-top: 15px;
}

.tongyi {
  margin-top: 15px;
}

.titel1 {
  font-size: 16px;
  font-weight: bold;
  display: block;
  margin-top: 15px;
}

.titel2 {
  font-size: 16px;
  font-weight: bold;
  display: block;
  margin-top: 3px;
}

.titel3 {
  font-size: 16px;
  display: block;
  margin-top: 3px;
}

.juzhong1 {
  display: flex;
  margin-top: 26px;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.tupian {
  width: 160px;
  height: 160px;
  margin-left: 45px;
  margin-top: 15px;
}

.tupian1 {
  width: 160px;
  height: 160px;
  margin-left: 50px;
  margin-top: 15px;
}

.juzhong {
  display: flex;
  margin-top: 10px;
  gap: 80px;
  text-align: left;
}

.weizhitupian {
  height: 401px;
  width: 350px;
}

.content {
  font-size: 16px;
  display: inline;
  font-weight: 400;
}


@media (max-width: 768px) {
  .addressimg {
    width: 75%;
    height: auto;
    margin-left: auto;
    margin-right: auto;
  }

  .juli {
    margin-left: 2%;
    margin-right: 2%;
  }

  .titel {
    margin-top: 8px;
    font-size: 15px !important;
    font-weight: 400;
    line-height:22px;
  }

  .tongyi {
    margin-top: 8px;
  }

  .titel1 {
    font-size: 15px !important;
    font-weight: bold;
    display: block;
    margin-top: 6px;
  }

  .titel2 {
    font-size: 15px !important;
    font-weight: bold;
    display: inline;
    margin-top: 6px;
  }

  .titel3 {
    font-size: 12px !important;
    display: inline;
    margin-top: 6px;
  }

  .tupianjuz {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tupian {
    width: 120px;
    height: 120px;
    margin-left: 0px;
    margin-top: 6px;
  }

  .tupian1 {
    width: 120px;
    height: 120px;
    margin-left: 0px;
    margin-top: 6px;
  }

  .juzhong {
    display: flex;
    margin-top: 0px;
    gap: 0px;
    text-align: left;
    flex-direction: column;
  }

  .weizhitupian {
    height: 200px;
    width: 170px;
  }

  .juzhong1 {
    display: flex;
    margin-top: 10px;
    align-items: center;
    justify-content: center;
    text-align: center;
  }


  .content {
    font-size: 13px !important;
    display: inline;
    font-weight:400;
  }

  .margintop {
    text-align: left;
    /* margin-top: 98px; */
    margin-bottom: 5px;
    margin-left: 2%;
    margin-right: 2%;
    font-size: 15px;
  }

  .tiaozhuan {
    margin-top: 100px;
    text-align: left;
    font-size:11px;
    margin-left: 2%;
  }

  /* 图片 */
  .biaoti {
    font-size: 15px;
    font-weight: 700;
  }

  .biaoti1 {
    font-size: 15px;
    font-weight: 700;
    margin-top: 8px;
  }

  .jianjie {
    margin-top: 5px;
    color: black;
    line-height: normal;
    font-size: 13px;
  }

  .fuwu01 {
    background-color: #ffc205;
    width: 348px;
    height: 146px;
    font-weight: 700;
    margin-top: 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .fuwu02 {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: 0px;
    font-size: 16px;
  }

  .fuwu03 {
    width: 52px;
    height: 52px;
    background-color: #fdff05;
    color: #4675c5;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .fuwu04 {
    width: 52px;
    height: 52px;
    margin-left: 11px;
    background-color: #fdff05;
    color: #4675c5;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .fuwu05 {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: 14px;
  }

  .fuwu06 {
    width: 52px;
    height: 52px;
    background-color: #4675c5;
    color: #fdff05;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .fuwu07 {
    width: 52px;
    height: 52px;
    margin-left: 11px;
    background-color: #4675c5;
    color: #fdff05;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .huanhang1 {
    margin-top: 0px;
    width: 295px;
    height: 189px;
    display: flex;
  }

  /* 我们的客户 */
  .juzhong {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 5px;
  }

  .kehu {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .kehu1 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0px;
    margin-top: 8px;
  }

  .dazi {
    height: 46px;
    width: 80px;
    border: 1px solid black;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 10px;
  }

  .zuoer {
    height: 46px;
    width: 80px;
    border-left: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    font-size: 10px;
    margin-top: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom-left-radius: 10px;
    flex-direction: column;
    text-align: left;
  }

  .fangkuai {
    list-style-type: square;
    margin-top: 0px;
    padding-left: 10px;
  }

  .youyi {
    height: 93px;
    width: 106px;
    border-top: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    flex-direction: column;
    text-align: left;
  }

  .yuanquan {
    list-style-type: circle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contact.vue